import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  EntityCollectionResponse,
  SubGeographiesVariables,
  SubGeography,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<SubGeographiesVariables, null>) {
  const { variables } = params;

  const {
    locator,
    countryCode,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    countryCode,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/DomainData/LocalizedMappingSubGeography${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<SubGeographiesVariables, null>({
  schema,
  dataPath: 'user:customer:sub_geography',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  keySelector: variables => variables.countryCode,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  SubGeographiesVariables,
  null,
  SubGeography,
  EntityCollectionResponse<SubGeography>,
  SubGeography[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: subGeography => subGeography.Key,

  processorFn: response => response.value,
});
